<template>
    <div>
        <loading-gdb :propObject="loading"></loading-gdb>
        <div class="title mb-4">
            Migração de Bolsas <helper-gdb text="Processo de migração de Bolsas UNDB"/>
        </div>
        <v-row>
            <v-col cols="12" sm="6">
                <v-select
                    v-model="payload.tipo"
                    label="Tipo Execução"
                    :items="[
                        {value: 's', title: 'Visualização'},
                        {value: 'i', title: 'Migração'},
                    ]"></v-select>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="6">
                <v-select
                    :disabled="pletivos.length == 0"
                    @update:modelValue="onChangePletivo"
                    return-object
                    label="Id Perlet"
                    :items="pletivos"
                    item-value="idperlet"
                    item-title="nome"
                    ></v-select>
            </v-col>
            <v-col cols="12" sm="6">
                <v-select
                    :disabled="scursos.length == 0"
                    v-model="payload.codcurso"
                    label="Curso"
                    :items="scursos"
                    item-value="codcurso"
                    item-title="nome"
                    ></v-select>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="3">
                <v-select
                    v-model="payload.nova_parc_inicial"
                    label="Nova Parcela Inicial"
                    :items="[1,7]"
                ></v-select>
            </v-col>
            <v-col cols="12" sm="3">
                <v-select
                    v-model="payload.nova_parc_final"
                    label="Nova Parcela Final"
                    :items="[6,12]"
                ></v-select>
            </v-col>
            <v-col cols="12" sm="3">
                <v-select
                    v-model="payload.antiga_parc_final"
                    label="Antiga Parcela Final"
                    :items="[6,12]"
                ></v-select>
            </v-col>
            <v-col cols="12" sm="12">
                <v-combobox
                    clearable
                    multiple
                    v-model="payload.codbolsas_lista_negra"
                    label="Lista negra de Bolsas"
                ></v-combobox>
            </v-col>
            <v-col cols="12" sm="12">
                <v-btn @click="set_migracao_bolsas"
                    :disabled="!payload.antiga_parc_final ||
                                !payload.nova_parc_inicial ||
                                !payload.nova_parc_final ||
                                !payload.novo_idperlet ||
                                !payload.codcurso
                                "
                    >{{payload.tipo =='s' ? 'Visualizar' : 'Migrar'}}</v-btn>
            </v-col>
            <v-divider class="my-2"></v-divider>
            <v-col cols="12" sm="12">
                {{(logs_migracao||[]).length}} Registro(s)
                <span v-for="l, index in logs_migracao" :key="index">
                    <v-alert color="primary">
                        {{l}}
                    </v-alert>
                </span>
            </v-col>
            <v-divider class="my-2"></v-divider>
            <v-col cols="12" sm="12">
                Pendentes sem bolsa ({{(logs_pente_fino||[]).length}})
                <span v-for="l, index in logs_pente_fino" :key="index">
                    <v-alert color="info">
                        {{l}}
                    </v-alert>
                </span>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    data: ()=>({
        loading: false,
        pletivos: [],
        scursos: [],
        logs_migracao:[],
        logs_pente_fino:[],
        payload: {
            tipo: "s",
            novo_idperlet: null,
            codcurso: null,
            nova_parc_inicial: null,
            nova_parc_final: null,
            antiga_parc_final: null,
            codbolsas_lista_negra: ["196","197","200","201","204","205","206","207","208","209","210","211","212","213","214","215","216","217","218","219","220","221","222","223","224","229","230","232","269","270","286","287","288","301","316","337","338","348","349","353","363","365","366","367","368","369","379","397","403","406","417","430","447","450","466","467","482","485","487","488","492","493","498","501","502","503","509","525","534","543","545","552","558","564","570","579","580","582","583","584","585","586","587","588","589","590","591","592","597","599","612","614","644","656","664","665","669","689","854","1346"]
        }
    }),
    methods:{
        ...mapActions(['SetMigracaoBolsas','GetPletivos', 'GetScursos']),
        async set_migracao_bolsas(){
            this.loading = true
            const response = await this.SetMigracaoBolsas(this.payload)
            if(response.status == 200){
                this.logs_migracao = response.data.migracao
                this.logs_pente_fino = response.data.pente_fino
            }else{
                this.logs_migracao = []
                this.logs_pente_fino = []
                alert(response.statusText)
            }
            this.loading = false
        },
        async init(){
            const response = await this.GetPletivos( { codtipocurso: [2], top: 10 } )
            if (response.status == 200){
                this.pletivos = response.data
            }
            const response_sc = await this.GetScursos({codtipocurso: 2})
            if (response_sc.status == 200){
                this.scursos = response_sc.data
            }
        },
        onChangePletivo(pletivo){
            if (pletivo.codperlet){
                // atualiza idperlet
                this.payload.novo_idperlet = pletivo.idperlet
                // valida inicial .1
                var ini_dot1 = pletivo.codperlet.indexOf('.1') !== -1 ? 1 : null
                // valida inicial .2
                var ini_dot2 = pletivo.codperlet.indexOf('.2') !== -1 ? 7 : null
                // valida inicial sem .1/.2
                var ini = pletivo.codperlet.indexOf('.') === -1 ? 1 : null
                // valida final .1
                var fin_dot1 = pletivo.codperlet.indexOf('.1') !== -1 ? 6 : null
                // valida final .2
                var fin_dot2 = pletivo.codperlet.indexOf('.2') !== -1 ? 12 : null
                // valida final sem .1/.2
                var fin = pletivo.codperlet.indexOf('.') === -1 ? 12 : null
                // assume parcela inicial
                var parcela_inicial = ini_dot1 | ini_dot2 | ini
                // assume parcela final
                var parcela_final = fin_dot1 | fin_dot2 | fin
                //atualiza parcela inicial
                this.payload.nova_parc_inicial =  parcela_inicial
                //atualiza parcela final
                this.payload.nova_parc_final =  parcela_final
                //atualiza antiga parcela final
                this.payload.antiga_parc_final = parcela_inicial == 1 ? 12 : 6
            }
        }
    },
    computed:{
        ...mapGetters(['StateInfoAlunoLoading'])
    },
    mounted(){
        this.init()
    }
}
</script>